import { Spinner } from "components/v2/spinner/spinner";
import "./overlay.scss";

const Overlay = ({
  text = "Loading...",
  subtext = "",
  displayFullScreen = true,
}: {
  text?: string;
  subtext?: string;
  displayFullScreen?: boolean;
}) => {
  return (
    <div className={`loading-overlay ${displayFullScreen ? "loading-overlay--fullscreen" : ""}`}>
      <Spinner isApi />
      <div className="loading-overlay__textblock">
        <h5>{text}</h5>
        <p>{subtext}</p>
      </div>
    </div>
  );
};

export default Overlay;
